/* eslint-disable */
import React, { Component } from "react";
import { reduxForm } from "redux-form";
import Loader from "react-loader";
import _ from "lodash";
import SelectField from "../../shared/SelectField";
import { transformYears } from "../../../utils/const";
import Rating from "./Rating";
import moment from "moment";

class PerformanceList extends Component {

  state = { 
    pathname: this.props.history.location.pathname, 
    firstRender: true, 
  };
  
  componentDidMount() {
    this.props.fetchYears()
    this.props.fetchRate()
    if (this.props.yearsList.length > 0) {
      const year = [...this.props.yearsList].pop().xp_key;
      this.props.fetchPerfList(year, this.screen());
      this.props.fetchTerms(year);
    }
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    const xp_key = !this.state.firstRender ? null : [...transformYears(this.props.yearsList)].reverse().filter(el => el.name.split('-')[[+moment(Date.now()).format('MM') < 9 ? 1 : 0]] == +moment(Date.now()).format('YYYY'))[0]?.value;

    if(xp_key) {
      this.props.fetchPerfList( xp_key, this.screen());
      this.setState({ 
        firstRender: false, 
      })
    }
  }


  screen = () => this.props.history.location.pathname !== "/performances";

  findNextTermData = ({ cid, termnum }) => {
    const progress = this.props.progress.find(
      (item) => item.cid === cid && item.termnum !== termnum
    );
    return (progress && progress.grade) || "";
  };

  resolveCourseName = (grade) =>
    parseInt(grade?.split(" ")?.slice(-1))
      ? grade
          ?.split(" ")
          ?.slice(0, -1)
          ?.join(" ")
      : grade;

  firstValue = (firstTerm, { grade, termnum }) =>
    firstTerm === termnum ? grade : "";

  secondValue = (firstTerm, { grade, termnum }) =>
    firstTerm !== termnum ? grade : "";

  componentWillReceiveProps(nextProps) {
    if (this.state.pathname !== nextProps.history.location.pathname) {
      this.props.reset();
      this.props.fetchPerfList(29, this.screen());
      this.setState({ pathname: nextProps.history.location.pathname });
    }
  }

  render() {
    const {
      isLoading,
      history,
      yearsList,
      fetchPerfList,
      progress,
      termsList,
      rateList,
      mid,
      getMarksList,
      fetchTerms,
      rateExam
    } = this.props;
    // const {selected, top} = this.state
    const terms = _.sortBy(termsList, (term) => term.trmid);
    const years = transformYears(yearsList);
    const firstTerm = progress && progress[0] && progress[0].termnum && (Number(progress[0].termnum)%2 ? progress[0].termnum : String(Number(progress[0].termnum)-1))
    const items = _.uniqBy(progress, "cid");
    const pathname = history.location.pathname;
    const courseNumber = items && items.length && items[0].kurs || 1

    return (
      <div className="23.jpg jpg23">
        <div className="captions">
          {pathname === "/performances"
            ? "Промежуточная аттестация"
            : "Итоговая аттестация"}
        </div>
        <div className="usp__inputs footer__float_left">
          <div className="inputs__name">Учебный год</div>
          <div className="inputs__input_schedule_small">
            <SelectField 
            className="form-control select__popup schedule__select" 
            name="yearId" 
            label="" 
            defaultValue={[...years].reverse().filter(el => el.name.split('-')[[+moment(Date.now()).format('MM') < 9 ? 1 : 0]] == +moment(Date.now()).format('YYYY'))[0]?.value } 
            options={[...years]}
            onChange={(e) => fetchPerfList(e.target.value, this.screen())}
            />
          </div>
        </div>
        <Loader loaded={!isLoading} color="#7b2b2a">
          <table className="tg-second new__tg">
            <tr>
              <th>
                Дисциплина
                <br />
              </th>
              <th>{`${courseNumber*2-1} семестр`}</th>
              <th>{`${courseNumber*2} семестр`}</th>
            </tr>
            {items.length > 0 &&
              items.map((course) => (
                <tr key={course.cid}>
                  <td>{this.resolveCourseName(course.meta_course_name)}</td>
                  <td
                    className="text-center"
                    onClick={() =>
                      history.push(
                        `/performances/${terms[0].trmid}/${course.cid}`
                      )
                    }
                  >
                    {this.firstValue(firstTerm, course)}
                  </td>
                  <td
                    onClick={() =>
                      history.push(
                        `/performances/${terms[1].trmid}/${course.cid}`
                      )
                    }
                  >
                    {this.findNextTermData(course) ||
                      this.secondValue(firstTerm, course)}
                  </td>
                </tr>
              ))}
          </table>
          <Rating 
            rateList={rateList} 
            mid={mid} 
            screen={screen} 
            fetchPerfList={fetchPerfList}
            pathname={pathname} 
            getMarksList={getMarksList}
            yearsList={yearsList}
            terms={termsList}
            fetchTerms={fetchTerms}
            rateExam={rateExam}/>
        </Loader>
      </div>
    );
  }
}

export default reduxForm({
  form: "performanceList",
  enableReinitialize: true,
})(PerformanceList);
